import * as React from "react";
import EmojiPicker, { Theme } from "emoji-picker-react";
import { Smile } from "lucide-react";
import { Button } from "./button";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { cn } from "../lib/utils";

export interface EmojiPickerButtonProps {
  onEmojiSelect: (emoji: string) => void;
  disabled?: boolean;
  className?: string;
}

export const EmojiPickerButton = ({
  onEmojiSelect,
  disabled,
  className,
}: EmojiPickerButtonProps) => {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          disabled={disabled}
          className={cn("shrink-0", className)}
          aria-label="Choisir un émoji"
        >
          <Smile className="h-5 w-5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto border-0 p-0 shadow-lg"
        align="start"
        side="top"
        sideOffset={8}
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <EmojiPicker
          theme={Theme.AUTO}
          onEmojiClick={(emoji) => {
            onEmojiSelect(emoji.emoji);
            setOpen(false);
          }}
          width={320}
          height={400}
          searchPlaceHolder="Rechercher..."
          previewConfig={{ showPreview: false }}
        />
      </PopoverContent>
    </Popover>
  );
};
